export const useDocumentStore = defineStore('required_document', {
    state: () => ({
        documents: [],
    }),
    actions: {
        async fetchDocuments(companyId: string, params?: any) {
            const { $api } = useNuxtApp()
            return $api().v2.requiredDocument.get(companyId, params).then(response => {
                this.documents = Array.isArray(response) ? response : [];
                return this.documents;
            });
        },
        async createDocuments(companyId: string, body?: any) {
            const { $api } = useNuxtApp()
            return $api().v2.requiredDocument.post(companyId, body).then(response => {
                return response;
            });
        },
        async downloadBillingMandate() {
            const { $api } = useNuxtApp();
            try {
                const blob = await $api().v2.billing.downloadMandate();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'mandat_de_facturation.pdf';
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error("Erreur lors du téléchargement du mandat de facturation:", error);
                // Optionnel: Afficher une notification d'erreur à l'utilisateur
            }
        }
    }
})